import { render, staticRenderFns } from "./ListAnnotationsUser.vue?vue&type=template&id=252f4cfc&scoped=true"
import script from "./ListAnnotationsUser.vue?vue&type=script&lang=js"
export * from "./ListAnnotationsUser.vue?vue&type=script&lang=js"
import style0 from "./ListAnnotationsUser.vue?vue&type=style&index=0&id=252f4cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252f4cfc",
  null
  
)

export default component.exports